import { v3 } from "oc-threejs/short3";

export const BOTTOM_TOP = "BOTTOM_TOP";
export const LEFT_RIGHT = "LEFT_RIGHT";
export const SCHRANK_NEIGHBORS = ["left", "right", "top", "bottom"];

export class SchrankConnector {
    // DO NOT CHANGE
    className = "SchrankConnector";
    // Eine Verbindung von zwei Schränken
    indices = [];
    rotation;
    rotationPossible;
    offset;
    backIndex;
    type;
    layout;
    linked = {
        x: false,
        y: false,
        z: false,
    };

    constructor(arrangement) {
        this.arrangement = arrangement;
    }

    static findConnector(schrank1, schrank2) {
        const connector = APP.arrangement.schrankConnectors.find((connector) => {
            return connector.schraenke.includes(schrank1) && connector.schraenke.includes(schrank2);
        });
        return connector;
    }

    static toBoxPosition(key, rotation, otherInEcke) {
        if (rotation) {
            if (otherInEcke) {
                switch (key) {
                    case "left":
                        return v3(0, 0, 1); //done
                    case "right":
                        return v3(1, 0, 1); //done
                }
            } else {
                switch (key) {
                    case "left":
                        return v3(0, 0, 0); //done
                    case "right":
                        return v3(1, 0, 0); //done
                }
            }
        } else {
            switch (key) {
                case "left":
                    return v3(0, 0, 0);
                case "right":
                    return v3(1, 0, 0);
                case "top":
                    return v3(0, 1, 0);
                case "bottom":
                    return v3(0, 0, 0);
            }
        }
    }

    static whatBoxPosition(key, rotation, otherInEcke) {
        if (rotation) {
            if (otherInEcke) {
                switch (key) {
                    case "left":
                        return v3(1, 0, 0); //done
                    case "right":
                        return v3(0, 0, 0); //done
                }
            } else {
                switch (key) {
                    case "left":
                        return v3(1, 0, 1); //done
                    case "right":
                        return v3(0, 0, 1); //done
                }
            }
        } else {
            switch (key) {
                case "left":
                    return v3(1, 0, 0);
                case "right":
                    return v3(0, 0, 0);
                case "top":
                    return v3(0, 0, 0);
                case "bottom":
                    return v3(0, 1, 0);
            }
        }
    }

    static calculatePositionWithOffset(position, direction, offset, isPartOfEckschrank, thisIsInEcke) {
        if (thisIsInEcke) {
            switch (direction) {
                case "left":
                    return position.setComponent(2, position.z + offset);
                case "right":
                    return position.setComponent(2, position.z + offset);
                case "top":
                    return position.setComponent(1, position.y + offset);
                case "bottom":
                    return position.setComponent(1, position.y - offset);
                default:
                    return position;
            }
        } else if (isPartOfEckschrank) {
            switch (direction) {
                case "left":
                    return position.setComponent(0, position.x - offset);
                case "right":
                    return position.setComponent(0, position.x + offset);
                case "top":
                    return position.setComponent(1, position.y + offset);
                case "bottom":
                    return position.setComponent(1, position.y - offset);
                default:
                    return position;
            }
        } else {
            switch (direction) {
                case "left":
                    return position.setComponent(0, position.x - offset);
                case "right":
                    return position.setComponent(0, position.x + offset);
                case "top":
                    return position.setComponent(1, position.y + offset);
                case "bottom":
                    return position.setComponent(1, position.y - offset);
                default:
                    return position;
            }
        }
    }

    get schraenke() {
        return this.indices.map((index) => {
            return APP.arrangement.schraenke[index];
        });
    }

    get backSchrank() {
        return APP.arrangement.schraenke[this.backIndex];
    }

    lock() {
        const layout = {};
        _.forEach(this.layout, (value, key) => {
            layout[key] = APP.arrangement.schraenke[value];
        });

        this._lock = {
            schraenke: this.schraenke,
            layout: layout,
            backSchrank: this.backSchrank,
        };
    }

    renew() {
        if (this._lock) {
            this.indices = this._lock.schraenke.map((schrank) => {
                return APP.arrangement.schraenke.indexOf(schrank);
            });

            const layout = {};
            _.forEach(this._lock.layout, (value, key) => {
                layout[key] = APP.arrangement.schraenke.indexOf(value);
            }),
                (this.layout = layout);

            this.backIndex = APP.arrangement.schraenke.indexOf(this._lock.backSchrank);
            this._lock = null;
        }
    }

    getOtherSchrank(schrank) {
        return this.schraenke.find((sch) => sch !== schrank);
    }

    isBackSchrank(schrank) {
        return APP.arrangement.schraenke[this.backIndex] === schrank;
    }

    fromJSON(json) {
        this.indices = json.indices || [];
        this.rotation = json.rotation || false;
        this.offset = json.offset || 0;
        this.backIndex = json.backIndex;
        this.type = json.type || undefined;
        this.layout = json.layout || undefined;
        this.rotationPossible = json.rotationPossible || false;
        return this;
    }

    toJSON() {
        return {
            className: this.className,
            indices: this.indices,
            rotation: this.rotation,
            offset: this.offset,
            backIndex: this.backIndex,
            type: this.type,
            layout: this.layout,
            rotationPossible: this.rotationPossible,
        };
    }

    // Dieser connector sucht sich die Aussagekräftige Zeile in multiSchrankConnections und ermittelt
    // Offset und Rotationsfähigkeit
    compile() {
        switch (this.type) {
            case "LEFT_RIGHT": {
                const leftSchrank = APP.arrangement.schraenke[this.layout.left];
                const rightSchrank = APP.arrangement.schraenke[this.layout.right];
                //zeile finden
                const combination = APP.metadata.multiSchrankKombinationen
                    .filter((combination) => combination.Position === "left_right" || combination.Position === "right_left")
                    .find(
                        (combination) =>
                            (combination.Inspiration_1 === leftSchrank.createdFromInspiration &&
                                combination.Inspiration_2 === rightSchrank.createdFromInspiration) ||
                            (combination.Inspiration_1 === rightSchrank.createdFromInspiration &&
                                combination.Inspiration_2 === leftSchrank.createdFromInspiration)
                    );

                if (combination) {
                    this.offset = combination.Abstand;
                    this.rotationPossible = combination.Drehbar;
                    this.linked = {
                        x: combination.Gekoppelt_x,
                        y: combination.Gekoppelt_y,
                        z: combination.Gekoppelt_z,
                    };
                } else {
                    APP.model.maybeThrowCompileError(this, "noConnector", "noConnectorText", leftSchrank, rightSchrank);
                }
                break;
            }
            case "BOTTOM_TOP": {
                const topSchrank = APP.arrangement.schraenke[this.layout.top];
                const bottomSchrank = APP.arrangement.schraenke[this.layout.bottom];
                //zeile finden
                const combination = APP.metadata.multiSchrankKombinationen
                    .filter((combination) => combination.Position === "top_bottom" || combination.Position === "bottom_top")
                    .find(
                        (combination) =>
                            (combination.Inspiration_1 === topSchrank.createdFromInspiration &&
                                combination.Inspiration_2 === bottomSchrank.createdFromInspiration) ||
                            (combination.Inspiration_1 === bottomSchrank.createdFromInspiration &&
                                combination.Inspiration_2 === topSchrank.createdFromInspiration)
                    );

                if (combination) {
                    this.offset = combination.Abstand;
                    this.rotationPossible = combination.Drehbar;
                    this.linked = {
                        x: combination.Gekoppelt_x,
                        y: combination.Gekoppelt_y,
                        z: combination.Gekoppelt_z,
                    };
                } else {
                    APP.model.maybeThrowCompileError(this, "noConnector", "noConnectorText", topSchrank, bottomSchrank);
                }
                break;
            }
        }
    }
}
